import { render, staticRenderFns } from "./type_popover.vue?vue&type=template&id=5d6adcda"
import script from "./type_popover.vue?vue&type=script&lang=js"
export * from "./type_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports